import { combineSlices, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { appointmentBookingSlice } from '../../features/appointments/store/appointment-bookings.slice';
import { appointmentDropInPositionSlice } from '../../features/appointments/store/appointment-drop-in-positions.slice';
import { appointmentDropInSlice } from '../../features/appointments/store/appointment-drop-ins.slice';
import { appointmentSlice } from '../../features/appointments/store/appointments.slice';
import { authenticationSlice } from '../../features/authentication/authentication.slice';
import { campusLocationSlice } from '../../features/campus-locations/store/campus-locations.slice';
import { dataExportsSlice } from '../../features/data-exports/store/data-exports.slice';
import { listItemInfoSlice } from '../../features/data-exports/store/list-item-info.slice';
import { eventSessionSlice } from '../../features/event-sessions/store/event-session.slice';
import { eventSlice } from '../../features/event-sessions/store/event.slice';
import { publicTokenSlice } from '../../features/public/store/public-token.slice';
import { pushNotificationSlice } from '../../features/push-notifications/store/push-notifications.slice';
import { createSignalRMiddleware } from '../../features/signalr/store/signalr.middleware';
import { signalRSlice } from '../../features/signalr/store/signalr.slice';
import { apiSlice } from '../api/api.slice';
import { appListener } from './listener.middlerware';

import '../../features/public/store/public-token.listener';
import '../../features/push-notifications/store/push-notification.listener';

export const rootReducer = combineSlices({
    [apiSlice.reducerPath]: apiSlice.reducer,
    authentication: authenticationSlice.reducer,
    events: eventSlice.reducer,
    eventSessions: eventSessionSlice.reducer,
    appointments: appointmentSlice.reducer,
    appointmentBookings: appointmentBookingSlice.reducer,
    appointmentDropIns: appointmentDropInSlice.reducer,
    appointmentDropInPositions: appointmentDropInPositionSlice.reducer,
    campusLocations: campusLocationSlice.reducer,
    pushNofications: pushNotificationSlice.reducer,
    dataExports: dataExportsSlice.reducer,
    listItemInfo: listItemInfoSlice.reducer,
    signalR: signalRSlice.reducer,
    publicToken: publicTokenSlice.reducer,
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware()
            .prepend(appListener.middleware)
            .concat(apiSlice.middleware, createSignalRMiddleware());
    },
    enhancers: (getDefaultEnchancers) => {
        return getDefaultEnchancers();
    },
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
